<template>
  <div class="exchange-component">
    <PaymentModal ref="paymentModal" @exchangePayment="exchangePayment" :errors="error" :loaderButton="loaderButton"
      :selectedExchange="selectedExchange" :selectedExchangeCurrency="selectedExchangeCurrency" />
    <div v-if="show2faPopup && !isPasswordNeeded">
      <div class="d-flex w-100 justify-content-start align-items-center back-block" v-on:click="closePopup()">
        <img src="../assets/img/back.svg" alt="back" />
        <div>Back</div>
      </div>
      <div class="cs-2fa">
        <img src="@/assets/img/lock.svg" alt="lock" class="cs-2fa__icon" />
        <div class="cs-2fa__title">
          {{ $t("rocketfuel-verify.title") }}
        </div>
        <div class="cs-2fa__description">
          {{ $t("rocketfuel-verify.description") }}
        </div>
        <TwoFA v-model.trim="code2fa" :count="6" @enter="exchangePayment(passwordData)" ref="code2fa"
          class="cs-2fa__2fa" />
        <div class="cs-2fa__error">
          {{ error2fa }}
        </div>
        <button class="cs-btn cs-btn_blue" @click="exchangePayment(passwordData)">
          {{ $t("rocketfuel-verify.confirm") }}
        </button>
      </div>
    </div>
    <div class="w-100" v-else>
      <div class="d-flex justify-content-center exchange-component__loader" v-if="loader">
        <b-spinner label="Loading..." />
      </div>

      <div v-else-if="selectedExchange">
        <div class="paywith">
          <div class="paywith__text_border-blue">
            <small>
              {{ $t("payment.pay-with") }}
            </small>
          </div>
          <div class="paywith__container">
            <img :src="getExchangeIcon(selectedExchange.name)" :alt="selectedExchange.name" />
            <span>{{ selectedExchange.name }}</span>
          </div>
          <!-- v-if="!option.connected && showConnect" -->
          <custom-button className="connect button-default-outline" :disabled="isPreview"
            @handle-click="handleConnect(selectedExchange)" :name="$t('tabs.buttons.connect')"
            v-if="!selectedExchange.connected" />
          <b-badge class="badge-connected button-default-outline pt-1 pb-1"
            v-if="selectedExchange.connected">Connected</b-badge>
          <div v-if="exchanges && exchanges.length > 1" class="paywith__arrow"
            @click="exchangeListControl = !exchangeListControl">
            <div class="dropdown-arrow">
              <img src="@/assets/img/arrow.svg" alt="arrow" />
            </div>
          </div>
        </div>
        <b-collapse ref="exchangeList" id="exchangeList" v-model:open="exchangeListControl">
          <div class="paywith" v-for="(exchange, i) in getFilteredExchanges(exchanges)" :key="i"
            v-on:click="selectExchange(exchange)">
            <div class="paywith__container">
              <img :src="getExchangeIcon(exchange.name)" :alt="exchange.name" />
              <span>{{ exchange.name }}</span>
            </div>
            <!-- v-if="!option.connected && showConnect" -->
            <custom-button className="connect button-default-outline" :disabled="isPreview"
              @handle-click="handleConnect(exchange)" :name="$t('tabs.buttons.connect')" v-if="!exchange.connected" />
            <div class="paywith__arrow" v-if="exchange.connected">
              <div class="dropdown-arrow">
                <small class="grey">{{
                  $t("unauth-payment.click-to-pay")
                }}</small>
              </div>
            </div>
          </div>
        </b-collapse>
        <div tag="article" style="max-width: 20rem" v-if="selectedExchange && selectedExchange.connected">
          <div class="paywith">
            <div class="paywith__text_border-orange">
              <small>
                {{ $t("payment.choose-currency") }}
              </small>
            </div>
            <div class="paywith__container-block" v-if="selectedExchangeCurrency && !isLoading">
              <div id="exchange-currency" v-if="selectedExchangeCurrency" class="">
                <div class="image-flex">
                  <div v-if="!currencyListControl" class="d-flex align-items-center">
                    <img class="icon" :src="selectedExchangeCurrency.logo" :alt="selectedExchangeCurrency.fullTitle" />
                    <span class="icon-name">{{
                      selectedExchangeCurrency.fullTitle
                    }}</span>
                  </div>
                  <div class="search-wrapper mt-2" v-else>
                    <input ref="searchInput" type="text" v-model="searchData" class="search-input"
                      placeholder="Search currencies" />
                    <span v-if="searchData !== ''" class="clear-data" @click="clearSearchData">
                      <img src="@/assets/img/close.svg" />
                    </span>
                  </div>
                  <div v-if="currencyToShow && currencyToShow.length" class="paywith__droparrow"
                    @click="currencyListControl = !currencyListControl">
                    <div class="dropdown-arrow">
                      <img src="@/assets/img/arrow.svg" alt="arrow" />
                    </div>
                  </div>
                </div>
                <div v-if="currencyListControl &&
                  searchData.length &&
                  !searchDataResults.length
                  " class="no-data">
                  No Currency found!
                </div>
                <div class="wallet-balance-wrapper" v-if="!currencyListControl">
                  <div class="grey">{{ $t("components.wallet-balance") }}</div>
                  <div v-if="selectedExchangeCurrency &&
                    selectedExchangeCurrency.fullTitle
                    " class="d-flex justify-content-between">
                    <div class="">
                      {{
                        Number(selectedExchangeCurrency.balance)
                        ? NumberFormat(
                          DecimalNumber(
                            selectedExchangeCurrency.balance
                          ).div(
                            DecimalNumber(
                              displayCurrency.currentRate &&
                                displayCurrency.currentRate > 0
                                ? displayCurrency.currentRate
                                : 1
                            ),
                            displayCurrency.decimals
                          )
                        )
                        : 0
                      }}
                      {{
                        String(selectedExchangeCurrency.currency).toUpperCase()
                      }}
                      {{
                        String(
                          selectedExchangeCurrency.currency
                        ).toUpperCase() === "USDT"
                        ? "(ERC20)"
                        : ""
                      }}
                    </div>
                    <div v-if="Number(selectedExchangeCurrency.currentRate) &&
                        Number(selectedExchangeCurrency.balance) &&
                        Number(displayCurrency.currentRate) &&
                        String(displayCurrency.id).toLowerCase() !==
                        String(
                          selectedExchangeCurrency.currency
                        ).toLowerCase()
                        " class="grey">
                      {{
                        getInLocalCurrency(
                          selectedExchangeCurrency,
                          displayCurrency
                        )
                      }}
                      {{ displayCurrency.id }}
                    </div>
                    <div v-else class="grey">
                      {{
                        getInLocalCurrency(
                          selectedExchangeCurrency,
                          displayCurrency
                        )
                      }}
                      {{ displayCurrency.id }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="p-2">
                <small>
                  <span class="error">{{
                    $t("exchange-payment.wallet-error")
                  }}</span>
                  {{ $t("exchange-payment.wallet-error-desc") }}
                </small>
              </div>
            </div>
            <div v-else class="paywith__loader my-2 d-flex justify-content-center">
              <Loading />
              <span class="italic ml-2 textloading">fetching balance</span>
            </div>
          </div>
          <!-- currency balances -->
          <b-collapse ref="currencyBalance" id="currencyBalance" v-model:open="currencyListControl">
            <div class="currency_dropdown">
              <div class="child-card-data" v-for="(currency, i) in searchDataResults || currencyToShow" :key="i">
                <div @click="handleSelectCurrency(currency)">
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                      <div class="icon mr-2">
                        <img :src="currency.logo" :alt="currency.currency" />
                      </div>
                      <div class="icon-name" :id="currency.currency">
                        {{
                          currency.fullTitle.length > 8
                          ? currency.fullTitle.substring(0, 8) + ".."
                          : currency.fullTitle
                        }}
                      </div>
                      <b-tooltip :target="currency.currency" triggers="hover" placement="top">
                        <span @click="handleSelectCurrency(currency)" class="tooltip-coin">{{ currency.fullTitle }}</span>
                      </b-tooltip>
                    </div>
                    <div class="balance-wrapper">
                      {{ currency.balance }} {{ currency.currency }}
                      {{
                        currency.currency.toUpperCase() === "USDT"
                        ? "(ERC20)"
                        : ""
                      }}
                      <div class="grey-text">
                        {{ getInLocalCurrency(currency, displayCurrency) }}
                        {{ displayCurrency.id }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-collapse>
        </div>
        <div class="d-flex justify-content-end align-items-center">
          <div class="networkfee" v-if="selectedExchange && selectedExchangeCurrency && networkFee">
            <small class="networkfee__title"> + Estimated Network Fee </small>
            <small class="networkfee__calculation" v-b-tooltip.hover :title="`${NumberFormat(
              DecimalNumber(networkFee).mul(
                DecimalNumber(conversionRate.currentRate).div(
                  DecimalNumber(displayCurrency.currentRate)
                ),
                displayCurrency.decimals
              ),
              2
            )}
                        ${displayCurrency.id}`">
              {{ parseFloat(networkFee.toString()).toFixed(8) }}
              {{ selectedExchangeCurrency.currency }}
              <!-- {{NumberFormat(DecimalNumber(networkFee).mul
           (DecimalNumber(conversionRate.currentRate)
            .div(DecimalNumber(displayCurrency.currentRate)), displayCurrency.decimals), 2)}}
              {{displayCurrency.id}} -->
            </small>
          </div>
        </div>
        <div v-if="Object.values(conversionRate).length &&
          Object.values(displayCurrency).length &&
          selectedExchange &&
          selectedExchange.connected
          " class="cs-payment__total">
          <div class="cs-payment__you-pay">
            {{ $t("payment.you-pay") }}
          </div>
          <div v-if="Object.values(payableData).length" class="cs-payment__amount">
            <!-- {{ NumberFormat(
            DecimalNumber(cart.amount)
            .mul(convertedCart.usdEquivalentRate !== undefined
            ? convertedCart.usdEquivalentRate : 1)
            .div(DecimalNumber(conversionRate.currentRate))) }} -->
            {{ payableData.payable_amount }}
            {{
              String(payableData.payable_currency).toUpperCase() == "USDT"
              ? "USDT(ERC20)"
              : String(payableData.payable_currency).toUpperCase()
            }}
          </div>
          <div v-else class="cs-payment__amount">
            $ {{ NumberFormat(cart.amount) }}
          </div>
        </div>
        <div
          v-if="Object.values(conversionRate).length &&
          Object.values(displayCurrency).length &&
          selectedExchange &&
          selectedExchange.connected &&
          payableData.stableCoinProcessingFee"
          class="cs-payment__convert_small text-right"
        >
            {{ '(includes '
              + payableData.stableCoinProcessingFee + ' '
              + payableData.payable_currency + ' processing fee)' }}
        </div>
        <div v-if="Object.values(conversionRate).length &&
          Object.values(displayCurrency).length &&
          String(conversionRate.id).toLowerCase() !==
          String(displayCurrency.id).toLowerCase() &&
          selectedExchange &&
          selectedExchange.connected
          " class="cs-payment__convert">
          <div class="cs-payment__convert_small">
            {{ $t("payment.conversion-rate") }}
          </div>
          <div class="cs-payment__convert_small">
            1
            {{
              conversionRate.id == "USDT" ? "USDT(ERC20)" : conversionRate.id
            }}
            =
            {{
              NumberFormat(
                DecimalNumber(conversionRate.currentRate).div(
                  DecimalNumber(
                    displayCurrency.currentRate &&
                      displayCurrency.currentRate > 0
                      ? displayCurrency.currentRate
                      : 1
                  )
                ),
                conversionRate.decimals
              )
            }}
            {{ displayCurrency.id }}
          </div>
        </div>
        <b-alert v-if="alertMessage" class="alert" variant="warning" show>
          <span v-html="alertMessage.replace('%%address%%', merchantWalletAddress)" />
          <div class="d-flex flex-row">
            Please verify that you are providing the correct address for your
            crypto currency. If the address is incorrect the transaction will
            fail!
          </div>
        </b-alert>
        <div v-if="selectedExchange &&
          selectedExchange.name !== 'coinbase' &&
          selectedExchange.connected
          " />
        <div v-if="error && !isLoading" class="cs-payment__error">
          <span>{{ error }}</span>
          <div v-if="limitError">
            <button class="limit-btn" @click="goToLimitReset()">
              <img :src="getExchangeIcon(this.selectedExchange.name + '-white')" :alt="this.selectedExchange.name" />
              <span> Change Limit </span>
            </button>
          </div>
        </div>
        <div class="exchange-info" v-if="!isPreview && selectedExchange && !selectedExchange.connected">
          <span>
            <img src="@/assets/img/info-payment.svg" />
          </span>
          <small v-if="selectedExchange && Object.keys(selectedExchange).length">
            {{
              $t("unauth-payment.info-exchange").replaceAll(
                "%%exchange%%",
                selectedExchange.name
              )
            }}.
          </small>
        </div>
        <div class="waiting-component" v-if="validatingPayment">
          <span>
            <img src="@/assets/img/noun_Hour.svg" />
          </span>
          <small> Please wait... </small>
        </div>
        <CustomButton v-if="selectedExchange &&
          selectedExchange.name &&
          !isPreview &&
          !limitError
          " :disabled="getDisabledStatus" :name="$t('payment.pay-with-crypto')" className="button-default w-100"
          @handle-click="exchangePayment()" class="continue-btn" :showLogo="marketInfo && !marketInfo.whiteLabel" />
      </div>
    </div>

    <!-- any whitelisting element can be shown here -->
    <b-modal v-model="showWhitelistElement" centered hide-footer hide-header>
      <div class="close-btn-container">
        <button class="close-btn" @click="showWhitelistElement = false">
          <img src="@/assets/img/close.svg" alt="close" />
        </button>
      </div>
      <div class="d-block text-center">
        <div class="qr-code-info mb-2" v-if="merchantWalletAddress && showWhitelistElement">
          <span>
            <img src="@/assets/img/info-payment.svg" />
          </span>
          <small>
            {{
              $t(
                `exchange-payment.${selectedExchange.name}-address-info`
              ).replace(
                "%%currency%%",
                this.selectedExchangeCurrency
                  ? this.selectedExchangeCurrency.currency.toUpperCase()
                  : ""
              )
            }}
          </small>
        </div>
        <div v-if="showWhitelistElement" class="cs-payment__merchant-address-wrapper mb-1">
          <input type="hidden" id="okCoinAddress" :value="merchantWalletAddress" />
          <button v-b-tooltip.hover :title="$t('unauth-payment.copy-okcoin-merchant-address')" class="cs-qr__copy"
            :class="{ 'cs-qr__copy_success': saved }" v-clipboard:copy="merchantWalletAddress" @click="copySuccess()">
            {{ $t("unauth-payment.copy-address") }}
          </button>
          <div class="d-flex align-right mt-2">
            <div class="cs-payment__exchange-link" @click="handleOpenVideo">
              Help Me
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal v-model="confirmDisconnect" hide-footer hide-header centered>
      <div class="confirm-modal" v-if="selectedExchange">
        <div class="confirm-modal__img-con">
          <img class="confirm-modal__img" :src="getExchangeIcon(selectedExchange.name)" :alt="selectedExchange.name" />
          <span class="confirm-modal__title">{{ selectedExchange.name }}</span>
        </div>
        <div class="confirm-modal__text">{{ error }}</div>
        <div class="d-flex justify-content-center align-items-center">
          <!-- <custom-button
                className="button-default-outline cancel"
                @handle-click="confirmDisconnect = !confirmDisconnect"
                name="Cancel"
              ></custom-button> -->
          <custom-button className="button-default-outline disconnect" :disabled="isPreview"
            @handle-click="disconnect(selectedExchange)" name="Ok" v-if="selectedExchange.connected" />
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
/* eslint-disable global-require */

/* eslint-disable prefer-destructuring */

import { mapGetters } from "vuex";
import {
  VALIDATE_EXCHANGE_PAYMENT,
  EXCHANGE_PAYMENT,
  CHECK_BALANCE,
  GET_STOCK_EXCHANGES,
  GET_MARKET_INFO,
  LIMIT_UPDATE,
  DEFAULT_EXCHANGE,
  DELETE_STOCK,
  GET_PAYABLE_AMOUNT,
  USER_TRACK_EVENTS,
  GET_USER_INFO,
  SET_RESULT_PAGE_DATA,
} from "@/store/modules/user/consts";
import PaymentModal from "@/components/PaymentModal.vue";
import Loading from "@/components/Loading.vue";
import TwoFA from "@/components/TwoFA.vue";
import { transactionSourceEnum } from "@/store/modules/user/enums";
import CustomButton from "../views/customButton.vue";
import { EXCHANGES } from "../utils/stringconsts";

export default {
  components: {
    // BCard,
    Loading,
    CustomButton,
    PaymentModal,
    TwoFA,
  },
  props: {
    isPreview: Boolean,
    stocksOptions: Array || [],
    displayCurrency: Object || [],
    convertedCart: Object || {},
    cartData: Object || {},
  },
  data() {
    return {
      loader: false,
      passwordData: null,
      code2fa: "",
      error2fa: "",
      validatingPayment: false,
      show2faPopup: false, // selected exchange
      selectedExchange: null,
      selectedExchangeCurrency: null, // selected currency for a exchange
      merchantWalletAddress: "", // merchant wallet address only if needed
      error: "", // error
      loaderButton: false,
      saved: false,
      availableLimit: null,
      isPasswordNeeded: false,
      limitWindow: false,
      errorcode: 0,
      // selectedExchangeLink: '',
      BASE_URL: process.env.VUE_APP_BASE_URL || "/api",
      resultData: {
        // eslint-disable-next-line
        icon: require("@/assets/img/success.svg"),
        title: this.$t("result.success"),
        description: this.$t("result.success-text"),
      },
      searchData: "",
      currencyToShow: [],
      exchanges: [],
      showNoData: false,
      currencyListControl: false,
      exchangeListControl: false,
      isLoading: false,
      showWhitelistElement: false,
      limitError: false,
      networkFee: 0,
      showWhitelistElementName: "",
      exchangeFetcherrCount: 0,
      confirmDisconnect: false,
      connectedBtnText: this.$t("tabs.buttons.connected"),
      alertMessage: null,
      payableData: {},
    };
  },

  computed: {
    ...mapGetters({
      cart: "user/cart",
      conversionInfo: "/user/conversionInfo",
      userInfo: "user/userInfo",
      stockExchanges: "user/getStockExchanges",
      currencies: "user/currencies",
      allStocks: "user/allStocks",
      paymentOptions: "user/paymentOptions",
      stateSelectedExchange: "user/getSelectedExchange",
      marketInfo: "user/marketInfo",
    }),
    getDisabledStatus() {
      const exceptionalErrorCodes = [420, 423, 424, 425];
      if (!this.selectedExchange || !this.selectedExchange.connected) {
        return true;
      }
      if (exceptionalErrorCodes.includes(this.errorcode)) {
        return false;
      }
      if (!this.merchantWalletAddress) {
        return true;
      }
      if (this.error) {
        return true;
      }
      return false;
    },
    conversionRate() {
      let rate = {};
      if (this.selectedExchangeCurrency && this.currencies) {
        this.currencies.forEach((item) => {
          if (Object.keys(this.selectedExchangeCurrency).length) {
            if (
              item.id.toLowerCase() ===
              this.selectedExchangeCurrency.currency.toLowerCase()
            ) {
              rate = item;
            }
          }
        });
        return rate;
      }
      return 0;
    },
    searchDataResults() {
      if (this.searchData && this.searchData.length) {
        return this.currencyToShow.filter(
          (val) =>
            val.currency
              .toLowerCase()
              .includes(this.searchData.toLowerCase()) ||
            val.fullTitle.toLowerCase().includes(this.searchData.toLowerCase())
        );
      }
      return null;
    },
  },
  mounted() {
    this.$nextTick(async () => {
      await this.getExchangesToStore();
      this.$store.dispatch(`user/${GET_USER_INFO}`);
    });
  },
  watch: {
    exchangeListControl: {
      handler(newVal) {
        if (newVal) {
          this.currencyListControl = false;
        }
      },
    },
    currencyListControl: {
      handler(newVal) {
        if (newVal) {
          this.exchangeListControl = false;
        }
      },
    },
    selectedExchange: {
      handler(newVal) {
        if (newVal) {
          this.alertMessage = null;
          this.checkBalance(0);
        }
      },
      deep: true,
    },
    selectedExchangeCurrency: {
      handler(newVal) {
        if (newVal) {
          this.alertMessage = null;
          this.validatePayment();
          this.merchantWalletAddress = null;
          this.getPayableData();
        }
      },
    },
    stockExchanges: {
      handler(newValue) {
        if (newValue) {
          this.exchanges = newValue.exchanges;
          this.setSelectedExchange();
        }
      },
      deep: true,
    },
    marketInfo: {
      handler() {
        this.setDefault();
      },
    },
  },
  methods: {
    async getExchangesToStore() {
      try {
        this.loader = true;
        this.$emit("setLoader", false);
        const data = await this.$store.dispatch(`user/${GET_STOCK_EXCHANGES}`, {
          clientId: this.cart.merchant_id,
          source: transactionSourceEnum.EXCHANGE,
        });
        const asked = this.$DbStorage.getItem('save-method');
        if (data && data.exchanges && data.exchanges.length & !asked) {
          if (data.exchanges.find((v) => v.connected)) {
            this.$DbStorage.setItem('save-method', 1);
            window.EventBus.emit("showModal");
          }
        }
        this.loader = false;
      } catch (err) {
        // eslint-disable-next-line no-alert
        if (this.exchangeFetcherrCount < 2) {
          this.exchangeFetcherrCount += 1;
          this.getExchangesToStore();
          return;
        }
        const payload = {
          merchantId: this.cart.merchant_id,
          source: transactionSourceEnum.EXCHANGE,
        };
        this.$store.dispatch(`user/${GET_MARKET_INFO}`, payload);
        this.loader = false;
        this.setDefault();
      }
    },
    closePopup() {
      this.show2faPopup = false;
    },
    getConversionRate(currency) {
      let rate = 0;
      if (this.currencies) {
        this.currencies.forEach((item) => {
          if (item.id.toLowerCase() === currency.toLowerCase()) {
            rate = item.currentRate;
          }
        });
        return rate;
      }
      return 0;
    },
    getFilteredExchanges(val) {
      if (val) {
        return val.filter(
          (v) =>
            v.name !== (this.selectedExchange ? this.selectedExchange.name : "")
        );
      }
      return [];
    },
    setDefault() {
      if (
        !this.stockExchanges.exchanges &&
        this.marketInfo &&
        this.marketInfo.exchanges
      ) {
        const def = this.marketInfo.exchanges;
        const filtered = def.filter(
          (v) => v.name !== "silamoney" && v.name !== "dwolla"
        );
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.exchanges = filtered;
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        // this.selectedExchange = this.exchanges[0];
      }
      if (this.stockExchanges && this.stockExchanges.exchanges) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.exchanges = this.stockExchanges.exchanges;
      }
      this.setSelectedExchange();
    },
    async handleDisconnect() {
      this.confirmDisconnect = true;
    },
    async disconnect(exchange) {
      try {
        this.confirmDisconnect = false;
        this.$emit("setLoader", true);
        await this.$store.dispatch(`user/${DELETE_STOCK}`, {
          id: exchange.stockId,
          source: transactionSourceEnum.EXCHANGE,
        });
        await this.$store.dispatch(`user/${GET_STOCK_EXCHANGES}`, {
          clientId: this.cart.merchant_id,
          source: transactionSourceEnum.EXCHANGE,
        });
        this.error = "";
        this.$emit("setLoader", false);
      } catch (err) {
        this.$emit("setLoader", false);
      }
    },
    async checkBalance(count) {
      // count
      if (this.selectedExchange && this.selectedExchange.connected) {
        this.isLoading = true;
        try {
          const data = {
            exchange: this.selectedExchange.value,
            clientId: this.cart.merchant_id,
            source: transactionSourceEnum.EXCHANGE,
          };
          const resp = await this.$store.dispatch(
            `user/${CHECK_BALANCE}`,
            data
          );
          this.currencyToShow = resp.data.result.accounts;
          if (this.stockExchanges && this.stockExchanges.defaultCurrency) {
            const def = this.currencyToShow.find(
              (v) => v.currency === this.stockExchanges.defaultCurrency
            );
            if (def) {
              this.selectedExchangeCurrency = def;
            } else {
              // eslint-disable-next-line prefer-destructuring
              this.selectedExchangeCurrency = this.currencyToShow[0];
            }
          }
          this.isLoading = false;
        } catch (err) {
          this.isLoading = false;
          if (
            err &&
            err.response &&
            err.response.data &&
            err.response.data.message
          ) {
            if (err.response.data.statusCode === 419) {
              await this.getExchangesToStore();
            }
            this.error = "";
            // eslint-disable-next-line no-param-reassign
            count += 1;
            if (count >= 3) {
              this.isLoading = false;
              this.error = err.response.data.message;
              if (err.response.status === 430) {
                // this.disconnect(this.selectedExchange);
                this.confirmDisconnect = true;
              }
            } else {
              this.checkBalance(count);
            }
          }
        }
      }
    },
    async exchangePayment(somepasswordData) {
      let passData = somepasswordData;
      if (passData) {
        this.passwordData = passData;
      }
      if (!this.passwordData) {
        passData = this.passwordData;
      }
      if (
        this.selectedExchange &&
        this.selectedExchange.connected &&
        this.merchantWalletAddress &&
        this.isPasswordNeeded &&
        !passData
      ) {
        this.$emit("setLoader", false);
        this.$refs.paymentModal.open();
        return;
      }
      if (
        (this.userInfo &&
          this.userInfo.is2faEnabled &&
          !this.code2fa &&
          !this.isPasswordNeeded) ||
        (this.userInfo &&
          this.userInfo.is2faEnabled &&
          !this.code2fa &&
          passData &&
          !this.isPasswordNeeded)
      ) {
        this.show2faPopup = true;
        this.$refs.paymentModal.close();
        return;
      }
      this.error = "";
      this.$nextTick(async () => {
        this.error = "";
        this.loaderButton = true;
        this.$emit("setLoader", true);
        try {
          const preData = {
            clientId: this.cart.merchant_id,
            assets: this.selectedExchangeCurrency.currency,
            cart: this.cart.cart,
            shippingAddress: this.cart.shippingAddress
              ? this.cart.shippingAddress
              : null,
            offerId: this.cart.order,
            confirmation: this.convertedCart.encrypted || "",
            nativeAmount: this.cart.amount,
            savepassword: false,
            code2fa: this.code2fa,
            hostedPageId: this.cart.uuid || "",
            merchantStoreCurrency: this.cart.currency,
          };
          if (passData && passData.password) {
            preData.fundpass = passData.password;
            preData.savepassword = passData.savepassword;
          }
          const data = this.Encrypt(preData);
          const payload = {
            exchange: this.selectedExchange.name,
            data,
            source: transactionSourceEnum.EXCHANGE,
          };
          const res = await this.$store.dispatch(
            `user/${EXCHANGE_PAYMENT}`,
            payload
          );
          if (res && res.data && res.data.ok) {
            this.$emit("setLoader", false);
            this.error = "";
            this.$store.dispatch(`user/${DEFAULT_EXCHANGE}`, {});
            this.$store.commit("auth/changePaymentCompleted");
            await this.$store.commit("user/clearCart");
            this.show2faPopup = false;
            this.passwordData = null;
            this.code2fa = "";
            if (this.userInfo && this.userInfo.ssoStatus) {
              this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
                moduleInfo: {
                  current: "Exchange",
                  activity: `paid using ${this.selectedExchange.name} exchange`,
                },
              });
              this.$router.push({ name: "Thank" });
            } else {
              this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
                moduleInfo: {
                  current: "Exchange",
                  activity: `paid using ${this.selectedExchange.name} exchange`,
                },
              });
              this.$store.dispatch(`user/${SET_RESULT_PAGE_DATA}`, this.resultData);
              this.$router.push({
                name: "Result",
              });
            }
            this.loaderButton = false;
          } else {
            this.error = "Payment cannot be processed!";
            this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
              moduleInfo: {
                current: "Exchange",
                activity: `paid using ${this.selectedExchange.name} failed`,
                error: this.error,
              },
            });
          }
        } catch (e) {
          if (this.show2faPopup) {
            if (e.response && e.response.data && e.response.data.message) {
              this.error2fa = e.response.data.message;
            } else this.error2fa = e.message;
          }
          this.errorcode = e.response.data.statusCode;

          this.passwordData = null;
          this.code2fa = "";
          this.$emit("setLoader", false);
          this.loaderButton = false;
          if (e.response) {
            // alert(JSON.stringify(e.response.data));
            this.error = e.response.data.message;
            if (
              e.response &&
              e.response.data &&
              e.response.data.statusCode &&
              // okcoin exception handling funds
              e.response.data.statusCode === 423
            ) {
              this.$emit("setLoader", false);
              this.isPasswordNeeded = true;
              this.$refs.paymentModal.open();
              // okcoin exception handling address whitelist
            } else if (e.response.data.statusCode === 425) {
              this.showWhitelistElement = true;
            } else if (
              e.response &&
              e.response.data &&
              e.response.data.statusCode &&
              // okcoin exception handling funds
              e.response.data.statusCode === 424
            ) {
              this.$emit("setLoader", false);
              this.isPasswordNeeded = true;
              this.$refs.paymentModal.open();
              this.showWhitelistElement = true;
            } else if (e.response.data.statusCode === 426) {
              // limit error
              this.limitError = true;
              this.goToLimitReset();
            }
          } else {
            this.error = e.message;
          }
          this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
            moduleInfo: {
              current: "Exchange",
              activity: `paid using ${this.selectedExchange.name} failed`,
              error: this.error,
            },
          });
        }
      });
    },
    goToLimitReset() {
      this.limitError = false;
      this.$emit("setLoader", true);
      this.goToResetPage(this.selectedExchange, this.selectedExchange.limit);
    },
    changeTextOnOver() {
      this.connectedBtnText = this.$t("tabs.buttons.disconnect");
    },
    changeTextOnLeave() {
      this.connectedBtnText = this.$t("tabs.buttons.connected");
    },
    setSelectedExchange() {
      if (this.exchanges && this.exchanges.length) {
        if (Object.keys(this.stateSelectedExchange).length) {
          const selected = this.exchanges.find(
            (val) => val.name === this.stateSelectedExchange.name
          );
          if (selected && selected.connected) {
            this.selectedExchange = selected;
            return;
          }
        }
        const defaultEX = this.exchanges.find((val) => val.default);
        if (defaultEX) {
          this.selectedExchange = defaultEX;
          return;
        }
        // selected exchanges which are connected and has a high priority
        const connected = this.exchanges.filter((val) => val.connected);
        if (connected.length) {
          const sorted = connected.sort((a, b) => b.priority - a.priority);
          this.selectedExchange = sorted[0];
          return;
        }

        const prioritize = this.exchanges.find((val) => val.priority === 1);
        if (prioritize) {
          this.selectedExchange = prioritize;
          return;
        }
        this.selectedExchange = this.exchanges[0];
      }
    },
    handleSelectCurrency(currency) {
      this.selectedExchangeCurrency = currency;
      this.limitError = false;
      this.error = "";
      this.currencyListControl = false;
      this.networkFee = 0;
    },
    selectExchange(exchange) {
      this.networkFee = 0;
      this.limitError = false;
      this.selectedExchangeCurrency = null;
      this.selectedExchange = exchange;
      this.$store.dispatch(`user/${DEFAULT_EXCHANGE}`, exchange);
      this.error = "";
      this.exchangeListControl = false;
      this.currencyListControl = false;
      this.merchantWalletAddress = null;
    },
    handleConnect(exchange) {
      this.error = "";
      this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
        moduleInfo: {
          current: "Exchange",
          activity: `clicked on connect exchange connect - ${exchange.name}`,
        },
      });
      // manipulating old codes
      const data = {
        ...exchange,
        connect: exchange.name,
      };
      this.setValue(data);
    },
    async updateLimit() {
      const payload = {
        exchange: this.selectedExchange.name,
        limit: this.availableLimit.toString(),
        source: transactionSourceEnum.EXCHANGE,
      };
      const resp = await this.$store.dispatch(`user/${LIMIT_UPDATE}`, payload);
      if (resp && resp.ok) {
        this.validatePayment();
        this.limitWindow = false;
        this.limitError = false;
        this.openPopup();
      }
    },
    async openPopup() {
      if (this.selectedExchange.name === "coinbase") {
        await this.$store.dispatch(`user/${DELETE_STOCK}`, {
          id: this.selectedExchange.stockId,
          source: transactionSourceEnum.EXCHANGE,
        });
        window.open(
          `https://www.coinbase.com/oauth/authorize/oauth_signin?account=all&client_id=${this.coinbaseClientId}&meta[account]=all&meta[send_limit_amount]=1&meta[send_limit_currency]=USD&meta[send_limit_period]=day&redirect_uri=${window.location.origin}/&response_type=code&scope=wallet:transactions:send wallet:accounts:read wallet:transactions:read`,
          "exchange_connect",
          `width=585, height=800, top=${(window.screen.height - 800) / 2
          }, left=${(window.screen.width - 585) / 2}, _blank`
        );
        this.$router.push({ name: "Payment" });
      }
    },
    geticon(currency) {
      let icon = "";
      try {
        icon = this.getCurrencyIcon(currency);
      } catch (e) {
        // eslint-disable-next-line no-param-reassign
        return require("../assets/img/default.png");
      }
      return icon;
    },
    getExchangeIcon(name) {
      let icon = "";
      try {
        icon = require(`@/assets/img/wallets/${name.toLowerCase()}.svg`);
      } catch (e) {
        // eslint-disable-next-line no-param-reassign
        return require("../assets/img/default.png");
      }
      return icon;
    },
    copySuccess() {
      const testingCodeToCopy = document.querySelector("#okCoinAddress");
      testingCodeToCopy.setAttribute("type", "text");
      testingCodeToCopy.select();
      try {
        const successful = document.execCommand("copy");
        const msg = successful ? "successful" : "unsuccessful";
      } catch (err) {
        // ('Oops, unable to copy');
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();

      this.saved = true;
      setTimeout(() => {
        this.saved = false;
      }, 500);
    },
    async validatePayment() {
      this.validatingPayment = true;
      this.limitError = false;
      if (
        this.selectedExchange &&
        this.selectedExchange.connected &&
        this.selectedExchangeCurrency &&
        this.selectedExchangeCurrency.currency
      ) {
        try {
          this.error = "";
          const data = this.Encrypt({
            clientId: this.cart.merchant_id,
            assets: this.selectedExchangeCurrency.currency,
            cart: this.cart.cart,
            offerId: this.cart.order,
            confirmation: false,
            nativeAmount: this.cart.amount,
            hostedPageId: this.cart.uuid || "",
            merchantStoreCurrency: this.cart.currency,
          });
          const payload = {
            data,
            exchange: this.selectedExchange
              ? this.selectedExchange.value
              : null,
            source: transactionSourceEnum.EXCHANGE,
          };
          this.error = "";
          const resp = await this.$store.dispatch(
            `user/${VALIDATE_EXCHANGE_PAYMENT}`,
            payload
          );
          this.validatingPayment = false;

          if (resp && resp.data && resp.data.ok) {
            const respdata = resp.data.result;
            if (
              this.selectedExchange &&
              respdata.exchange === this.selectedExchange.name
            ) {
              this.showWhitelistElement = respdata.showWhitelistElement;
              this.networkFee = respdata.fee;
              this.showWhitelistElementName = respdata.exchange;
              this.merchantWalletAddress = respdata.receiverAddress;
              this.isPasswordNeeded = respdata.password;
              this.alertMessage = respdata.message ? respdata.message : null;
            }
          }
        } catch (e) {
          this.validatingPayment = false;

          // eslint-disable-next-line no-alert
          if (e.response && e.response.data) {
            this.errorcode = e.response.data.statusCode;
            if (e.response.status && e.response.status === 426) {
              // limit error
              this.limitError = true;
            }
            if (e.response && e.response.data) {
              this.error = e.response.data.message;
              // eslint-disable-next-line no-dupe-else-if
            } else if (e.response && e.response.data && e.response.data.data) {
              this.error = e.response.data.data.message;
            } else if (e.message) {
              this.error = e.message;
            }
          } else {
            this.error = e.message;
          }
        }
      }
    },
    clearSearchData() {
      this.searchData = "";
      // this.displayOptions.others = this.options;
      this.showNoData = false;
    },
    restrictSpace(event) {
      if (event.keyCode === 32) {
        event.stopPropagation();
      }
    },
    handleOpenVideo() {
      const url = EXCHANGES[0].whiteListKeys[0].video;
      window.open(
        `${process.env.VUE_APP_FRONTEND_HELP_URL}/videoplayer/?link=${url}`,
        "video_player",
        `width=${window.screen.width / 2}, height=450, top=${(window.screen.height - 400) / 2
        }, left=50, resizable=0,menubar=no,location=no,resizable=no,scrollbars=no,status=yes,_blank`
      );
    },
    // set values to default on exchange selected
    setDefaults() {
      this.isPasswordNeeded = false;
      this.merchantWalletAddress = null;
      this.showWhitelistElement = false;
    },
    getCartAmountWithExchangeRate(
      amount,
      shopperExchangeRate = 0,
      shopperFiatExchangeRate
    ) {
      const shopperRate =
        shopperExchangeRate ||
        (this.marketInfo && this.marketInfo.merchant.shopperNewRate
          ? this.marketInfo.merchant.shopperNewRate
          : 0);

      // shopper Flat Rate
      const shopperFlatRate =
        shopperFiatExchangeRate ||
        (this.marketInfo && this.marketInfo.merchant.shopperFiatExchangeRate
          ? this.marketInfo.merchant.shopperFiatExchangeRate
          : 0);
      // calulate the total amount
      const perc = parseFloat(
        this.DecimalNumber(amount).div(100).mul(shopperRate)
      );
      const total = parseFloat(
        this.DecimalNumber(amount)
          .plus(this.DecimalNumber(perc))
          .plus(this.DecimalNumber(shopperFlatRate))
      );
      return parseFloat(total);
    },
    async getPayableData() {
      try {
        const resp = await this.$store.dispatch(`user/${GET_PAYABLE_AMOUNT}`, {
          cc: this.selectedExchangeCurrency.currency,
          invoice: this.cart.uuid,
        });
        this.payableData = resp;
      } catch (err) {
        //todo
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.child-card-data {
  border: 1px solid #e2e2e6;
  padding: 8px;
  cursor: pointer;
  margin-bottom: 5px;
}

.icon {
  display: flex;
  align-items: center;

  img {
    width: 30px;
  }
}

.icon-name {
  font-size: 14px;
  padding: 8px 10px 5px 10px;
  // display: inline-block;
  flex-grow: 1;
  // width: 90px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.bold {
  font-weight: 700;
}

.large {
  font-size: 22px;
  margin-left: 5px;
}

.grey {
  color: #8d92a3;
}

.balance {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  width: 100%;
}

.italic {
  font-style: italic;
}

.exchange-info {
  display: flex;
  border: 1px solid #d7d8d6;
  padding: 12px 8px;
  border-radius: 4px;
  color: #6b7390;
  background: #fff;
  line-height: 15px;
  margin-top: 5px;
  margin-bottom: 10px;

  span {
    margin-right: 10px;

    img {
      width: 50px;
    }
  }
}

.qr-code-info {
  display: flex;
  border: 1px solid #d7d8d6;
  padding: 12px 8px;
  border-radius: 4px;
  align-items: center;
  line-height: 15px;

  span {
    margin-right: 10px;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background: #fff;

    img {
      width: 25px;
    }
  }
}

.qr-code-info-exchange {
  margin-top: 0px;
  margin-bottom: 10px;
}

.conversion {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  flex-flow: column;
  padding: 5px;
}

.image-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
  position: relative;
}

.currency_dropdown {
  max-height: 35vh;
  overflow-y: auto;
  scrollbar-color: #ededee white;
  scrollbar-width: thin;
  margin: auto;
  width: 95%;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: white;
  }

  &::-webkit-scrollbar-thumb {
    background: #ededee;
    border-radius: 8px;
  }
}

.paywith {
  padding: 5px;
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  flex-flow: row;
  align-items: center;
  // justify-content: space-between;
  flex-grow: 1;

  // cursor: pointer;
  &__spinner {
    margin-right: 6px;
    width: 15px;
    height: 15px;
  }

  &__text {
    &_border-orange {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #ededee;
      color: #1b1f3b;
      padding: 10px;
      align-self: baseline;
      width: 30%;
      line-height: 15px;
      border-left: 4px solid #ff7a00;
    }

    &_border-blue {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #ededee;
      color: #1b1f3b;
      padding: 10px;
      width: 30%;
      line-height: 15px;
      border-left: 4px solid #5e72e4;
    }
  }

  &__container {
    padding: 5px 10px;
    align-items: center;
    display: flex;
    flex-grow: 1;

    img {
      width: 1.5em;
      height: 1.5em;
    }

    span {
      font-size: 14px;
      padding: 0 10px;
      text-transform: capitalize;
    }
  }

  &__container-block {
    padding: 5px 10px;
    display: flex;
    flex-flow: column;
    flex-grow: 1;
    font-size: 12px;

    // margin-bottom: 15px;
    img {
      width: 2.25em;
      height: 2.25em;
    }

    span {
      padding: 0 10px;
      text-transform: capitalize;
    }

    .search-wrapper {
      position: relative;
      display: flex;
      width: 160px;

      .search-input {
        width: 100%;
        border: 1px solid #ededee;
        padding: 5px;
        font-size: 14px;
        color: #1b1f3b;

        &::placeholder {
          font-size: 14px;
          color: #ededee;
        }
      }

      .clear-data {
        cursor: pointer;

        img {
          display: inline-block;
          position: absolute;
          width: 8px;
          // right: 8px;
          // top: 12px;
        }
      }
    }
  }

  &__loader {
    flex-grow: 1;
    align-items: center;
    font-size: 12px;
    width: 80px;
  }

  .connect {
    font-size: 12px;
    padding: 0 10px;
    height: 25px;
  }

  .connected {
    font-size: 12px;
    padding: 0 5px;
    height: 25px;
    color: #4bb543 !important;
    border-color: #4bb543 !important;

    &:hover {
      background: #f24f4f !important;
      color: #fff !important;
      border-color: #fff !important;
    }
  }

  .badge-connected {
    border: 1px solid #4bb543 !important;
    color: #4bb543 !important;

    &:hover {
      background: #fff !important;
    }
  }

  &__droparrow {
    padding: 5px 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    position: absolute;
    right: -15px;

    .dropdown-arrow {
      margin-left: 5px;

      img {
        width: 0.7em;
        width: 0.7em;
      }
    }
  }

  &__arrow {
    padding: 5px 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    .dropdown-arrow {
      margin-left: 5px;

      img {
        width: 0.7em;
        width: 0.7em;
      }
    }
  }
}

.wallet-balance-wrapper {
  font-size: 12px;
  padding: 5px;

  .grey {
    color: #8d92a3;
  }
}

.balance-wrapper {
  word-break: break-all;
  font-size: 14px;

  .grey-text {
    color: #828ba1;
    text-align: right;
  }
}

.cs-payment {
  padding: 140px 20px 20px;
  display: grid;
  gap: 15px;

  &__title {
    font-size: 20px;
    font-weight: 700;
  }

  &__text {
    font-weight: 300;
    font-size: 16px;
    line-height: 27px;
  }

  &__convert {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    color: $grey;
    margin-bottom: 8px;

    &_small {
      font-weight: 300;
      font-size: 14px;
      line-height: 23px;
      margin-right: 5px;
    }
  }

  &__rate {
    margin-left: 10px;
    font-weight: 600;
    font-size: 12px;
    line-height: 1;
  }

  &__total {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin: -5px 0px;
  }

  &__you-pay {
    font-weight: 300;
    font-size: 16px;
    line-height: 27px;
  }

  &__amount {
    font-weight: 800;
    font-size: 22px;
    line-height: 38px;
    margin-left: 8px;
  }

  &__limit-exceed {
    display: flex;
    color: #ff3359;
    font-size: 15px;
    font-weight: 500;

    span {
      width: 25px;
      margin-right: 10px;
    }
  }

  &__error {
    display: flex;
    flex-flow: column;
    justify-content: center;
    width: 100%;
    color: #f53d3d;
    margin-bottom: 5px;
    margin-top: 10px;
    font-size: 12px;
    line-height: 1.2;
    min-height: 16px;
    font-weight: 400;
  }

  &__qr-code-info {
    display: flex;
    border: 1px solid #d7d8d6;
    padding: 12px 8px;
    border-radius: 4px;
    color: #6b7390;
    line-height: 15px;

    span {
      margin-right: 10px;

      img {
        width: 50px;
      }
    }
  }

  &__bank-info {
    display: flex;
    border: 1px solid #d7d8d6;
    padding: 12px 8px;
    border-radius: 4px;
    color: #6b7390;
    line-height: 15px;

    span {
      margin-right: 10px;

      img {
        width: 25px;
      }
    }
  }

  &__checking-payment {
    display: flex;
    color: #ff7500;
    justify-content: center;

    span {
      margin-right: 10px;

      img {
        width: 13px;
        animation: rotation 2s infinite linear;

        @keyframes rotation {
          100% {
            transform: rotate(360deg);
          }
        }
      }
    }
  }

  &__partial-payment {
    display: flex;
    color: #ff7500;
    line-height: 15px;

    span {
      margin-right: 10px;

      img {
        width: 35px;
      }
    }
  }

  &__payment-processed {
    display: flex;
    color: #42cd69;
    justify-content: center;
    align-items: center;

    div {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #42cd69;
      border-radius: 50%;
      height: 18px;
      width: 18px;
      padding: 2px;
      margin-right: 10px;

      img {
        width: 12px;
      }
    }
  }

  &__merchant-address-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    flex-flow: column;
  }

  &__exchange-link {
    color: #4989f4;
    cursor: pointer;
    font-size: 12px;
    text-align: right;
    text-decoration: underline;
    align-self: end;
  }
}

.back-block {
  cursor: pointer;
  gap: 5px;
}

.cs-qr {
  padding: 15px;
  background: $gradient-grey;
  border: 1px solid $border;
  border-radius: 1px;
  display: flex;

  &__code {
    margin-right: 15px;
    width: 135px;
    min-width: 135px;
    height: 135px;
  }

  &__info {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  &__coin-box {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  &__icon {
    width: 21px;
    min-width: 21px;
    height: 21px;
    object-fit: contain;
    border-radius: 50%;
    margin-right: 10px;
  }

  &__name {
    font-size: 14px;
    line-height: 17px;
  }

  &__amount {
    font-weight: 600;
    font-size: 18px;
    line-height: 21px;
  }

  &__convert {
    font-weight: 300;
    font-size: 14px;
    line-height: 23px;
    color: $black400;
    margin-bottom: 8px;
  }

  &__hr {
    width: 100%;
    height: 1px;
    background-color: $black300;
  }

  &__copy {
    height: 31px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border: 1px solid $blue400;
    border-radius: 1px;
    font-size: 14px;
    line-height: 23px;
    color: $blue500;
    margin-top: auto;
    margin-left: auto;
    transition: 0.3s;

    &:hover {
      border-color: $blue500;
      color: $blue600;
    }

    &_success {
      border-color: $green500 !important;
      color: $green500 !important;
    }
  }
}

.cs-2fa {
  padding: 10px 20px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;

  &__back {
    position: absolute;
    top: 70px;
    left: 20px;
  }

  &__2fa {
    margin-bottom: 7px;
  }

  &__error {
    width: 100%;
    color: $red500;
    margin-bottom: 9px;
    margin-top: 15px;
    font-size: 16px;
    line-height: 1;
    min-height: 16px;
  }

  &__icon {
    height: 33px;
    margin-bottom: 15px;
  }

  &__title {
    text-align: center;
    font-weight: 500;
    font-size: 22px;
    line-height: 37px;
    margin-bottom: 2px;
  }

  &__description {
    font-weight: 300;
    font-size: 13px;
    line-height: 22px;
    margin-bottom: 30px;
  }

  &__resend {
    height: 33px;
    width: 98px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: $gradient-grey;
    border: 1px solid $border;
    border-radius: 1px;
    font-size: 16px;
    line-height: 27px;
    margin-bottom: 42px;
  }
}

.error {
  width: 100%;
  color: #f53d3d;
  margin-bottom: 5px;
  margin-top: 10px;
  font-size: 12px;
  line-height: 1.2;
  min-height: 16px;
  font-weight: 400;
}

.align-right {
  align-self: flex-end;
}

.modal-header {
  padding: 10px 15px !important;
}

.close-btn-container {
  display: flex;
  justify-content: flex-end;
}

.close-btn {
  @include gradient-box;
  background-color: $white;
  width: 30px;
  min-width: 30px;
  height: 30px;
  object-fit: contain;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.3s;
  border: none;

  & img {
    width: 12px;
  }

  &:hover {
    background-color: $gradient-grey;
  }
}

.limit-field {
  display: block;
  color: #333;
  margin-bottom: 10px;
}

.link {
  color: #4989f4;
  cursor: pointer;
  font-size: 12px;
  text-align: right;
  align-self: end;
}

.limit-input {
  padding: 5px;
  width: 60px;
  text-align: center;
}

.limit-btn {
  width: 100%;
  align-items: center;
  color: #fff;
  display: flex;
  flex-flow: row;
  text-transform: uppercase;
  background: #fc8301;
  padding: 7px;
  margin-top: 10px;
  border: none;
  cursor: pointer;
  border-radius: 3px;
  padding: 8px 30px;
  font-size: 14px;

  img {
    width: 25px;
  }

  span {
    margin-left: 25%;
  }
}

.networkfee {
  padding: 2px 5px;
  cursor: default;

  &__title {
    font-size: 11.5px;
    margin-left: 5px;
    color: #6e728b;
  }

  &__calculation {
    font-size: 11.5px;
    color: #6e728b;
  }
}

a.badge-success:focus {
  box-shadow: none !important;
}

.tooltip-coin {
  cursor: pointer;
}

.exchange-component {
  // min-height: 100px;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  &__loader {
    padding: 120px 0;
  }
}

.confirm-modal {
  width: 90%;
  display: flex;
  align-items: center;
  flex-flow: column;
  justify-content: center;
  line-height: 40px;
  margin: auto;

  &__img-con {
    display: flex;
    align-items: center;
  }

  &__img {
    width: 30px;
  }

  &__text {
    font-weight: 500;
  }

  &__title {
    text-transform: uppercase;
    font-size: 18px;
    margin-left: 10px;
    color: #0052ff;
    font-weight: 600;
  }
}

.disconnect {
  color: #fff !important;
  background: #fc8301 !important;
  margin: auto;
  border-color: unset !important;
  border: none !important;
}

.cancel {
  border-color: unset !important;
  border: none !important;
  color: #fff !important;
  margin-right: 30px;
  background: #9d9d9d !important;

  &:hover {
    background: #ddd !important;
    color: #fff !important;
  }
}

.disconnect,
.cancel {
  height: 30px;
  padding: 0 10px;
  width: 100px;
}

.waiting-component {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: row;
  margin: 10px 5px;

  img {
    width: 15px;
    margin-right: 15px;
    animation: rotation 2s infinite linear;

    @keyframes rotation {
      100% {
        transform: rotate(360deg);
      }
    }
  }
}

.textloading {
  width: 110px;
}

.textloading:after {
  overflow: hidden;
  display: inline-block;
  vertical-align: bottom;
  -webkit-animation: ellipsis steps(4, end) 900ms infinite;
  animation: ellipsis steps(4, end) 900ms infinite;
  content: "\2026";
  /* ascii code for the ellipsis character */
  width: 0px;
}

.alert {
  overflow-wrap: anywhere;
  font-size: 12px;
  word-break: break-all;
}

.logo {
  width: 15px;
  height: 15px;
  margin-right: 5px;
  justify-self: center;
}

@keyframes ellipsis {
  to {
    width: 20px;
  }
}

@-webkit-keyframes ellipsis {
  to {
    width: 20px;
  }
}
</style>
